import moment from "moment";

// The date control doesn't allow picking a past date, but re-opening a quote
// created a few days earlier can leave its original (now past) pickup date set.
export function bookShipmentIsPickupDateInThePast(pickupDate: string): boolean {
  return moment(pickupDate).startOf("day").isBefore(moment().startOf("day"));
}
